import React from 'react';
import { Reveal } from './Reveal';
const stats = [{
  value: '+2.800',
  label: 'Personas transformadas'
}, {
  value: '98%',
  label: 'Lo recomiendan'
}, {
  value: '6',
  label: 'Módulos de conocimiento'
}, {
  value: '3',
  label: 'Bonos de regalo'
}];
export function Stats() {
  return <section className="w-full bg-brand-dark" data-id="element-175" data-mp="2nws8tpfq42xq">
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-6 px-5 py-10 sm:py-12 lg:grid-cols-4" data-id="element-176" data-mp="2nvh2piyt2j3g">
        {stats.map((s, i) => <Reveal key={s.label} delay={i * 0.08} className="text-center" data-id="element-177" data-mp="2dyuhuu6hbs1f" data-mpi={i}>
            <p className="font-display text-3xl font-bold text-white sm:text-4xl" data-id="element-178" data-mp="2e05p53z4vhxa">{s.value}</p>
            <p className="mt-1 text-sm font-medium text-white/70" data-id="element-179" data-mp="209ak62rr9kyz">{s.label}</p>
          </Reveal>)}
      </div>
    </section>;
}